<template>
  <!-- eslint-disable -->
<v-container fluid>
<v-slide-y-transition mode="out-in">
  <div>
    {{date}}
    <v-speed-dial v-model="fab" right top fixed direction="bottom" transition="slide-y-reverse-transition">
      <template v-slot:activator>
        <v-btn class="refresh-btn" v-model="fab" color="blue darken-2" dark fab>
          <v-icon v-if="fab">close</v-icon>
          <v-icon v-else>account_circle</v-icon>
        </v-btn>
      </template>
      <v-btn fab dark small class="refresh-hours-btn" color="red" @click="loadHours()">
        <v-icon>refresh</v-icon>
      </v-btn>
    </v-speed-dial>
    
    <v-dialog v-model="dialog" max-width="500px">
      <template v-slot:activator="{ on }">
        <v-btn v-on="on" color="primary" dark class="add-hours-btn mb-2">Add</v-btn>
      </template>
      <v-card>
        <v-form v-model="valid" ref="form" lazy-validation>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-container grid-list-md>
              <v-layout row wrap>
                <v-flex xs12>
                  <v-menu ref="menu1"
                          :close-on-content-click="false"
                          v-model="menu1"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          id="time-picker-menu"
                          class="time-picker-menu"
                          max-width="290px"
                          min-width="290px">
                    <template v-slot:activator="{ on }">
                      <v-text-field id="time-picker-text" v-on="on"
                            class="time-picker-text"
                            v-model="editedItem.WeekEnding"
                            :rules="[rulesRequired]"
                            label="Week Ending"
                            hint="YYYY-MM-DD format"
                            persistent-hint
                            prepend-icon="event"
                            readonly></v-text-field>
                    </template>
                    <v-date-picker id="time-picker-calendar" :allowed-dates="allowedDates" v-model="editedItem.WeekEnding" no-title @input="menu1 = false"></v-date-picker>
                  </v-menu>
                </v-flex>
                <v-flex xs12>
                  <v-select class="group-select" :items="groups" item-text="Name" item-value="Id" label="Group" single-line v-model="editedItem.CompanyGroupId" :rules="[rulesRequired]" prepend-icon="store"></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-text-field class="hours-input" label="Hours" single-line v-model="editedItem.Hours" :rules="[rulesRequired, rulesValidHours]" prepend-icon="alarm"></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" class="cancel-add-btn" text @click="close">Cancel</v-btn>
            <v-btn color="blue darken-1" class="save-btn" text @click="save">Save</v-btn>
          </v-card-actions>

        </v-form>
      </v-card>
    </v-dialog>
    <v-dialog v-model="deleteDialog" max-width="400px">
      <v-card>
        <div style="text-align: center; padding: 25px;">
          <h3>Are you sure you want to delete this item?</h3>
          <v-btn class="confirm-delete" @click="deleteItem" color="red"><v-icon>delete</v-icon> Delete</v-btn>
          <v-btn @click="closeDeleteDialog"><v-icon>close</v-icon> Cancel</v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-data-table :mobile-breakpoint="0" class="hours-data-table" disable-pagination hide-default-footer :items="hours" item-key="Id" :headers="headers" :loading="loading" :sort-by.sync="sortBy" :sort-desc.sync="descending">
      <template v-slot:item="{ item }" item-key="HashKey">
        <tr>
          <td>
            {{item.WeekEnding | formatWholeDate}}
          </td>
          <td>
            {{item.CompanyGroup.Name}}
          </td>
          <td>
            {{item.Hours}}
          </td>
          <td class="justify-left layout px-0">
            <v-icon small
                    class="edit-hours-btn mr-2"
                    @click="editItem(item)">
              edit
            </v-icon>
            <v-icon small class="delete-hours-btn"
                    @click="openDeleteDialog(item.Id)">
              delete
            </v-icon>
          </td>
        </tr>
      </template>
      <template slot="no-data">

        <div v-if="loading" class="text-xs-center">
          Loading data. . .
        </div>
        <div v-else class="text-xs-center">
          No data entered
        </div>

      </template>
    </v-data-table>


  </div>
</v-slide-y-transition>
  </v-container>
<!-- eslint-enable -->
</template>
<script>
import timeTrackingModule, {
  TIMETRACKING_NAMESPACE
} from "./store/timeTrackingStore";
import moment from "moment";
import { mapGetters } from "vuex";
import RulesMixin from "@/mixins/RulesMixin.js";

export default {
  name: "Timetracking",
  mixins: [RulesMixin],
  data() {
    return {
      formHasErrors: false,
      date: null,
      deleteDialog: false,
      deleteId: null,
      menu1: false,
      valid: false,
      dialog: false,
      fab: false,
      snackbarTimeout: 99999,
      sortBy: "WeekEnding",
      descending: true,
      headers: [
        {
          text: "Week Ending",
          sortable: true,
          align: "left",
          value: "WeekEnding"
        },
        {
          text: "Group",
          sortable: true,
          align: "left",
          value: "CompanyGroup.Name"
        },
        {
          text: "Hours",
          sortable: true,
          align: "left",
          value: "Hours"
        },
        {
          text: "Actions",
          sortable: false,
          value: "Id"
        }
      ],
      editedItem: {
        Id: null,
        WeekEnding: null,
        WeekEndingFormatted: "",
        CompanyGroup: {},
        CompanyGroupId: null,
        Hours: null
      },
      defaultItem: {
        Id: null,
        WeekEnding: null,
        WeekEndingFormatted: "",
        CompanyGroup: {},
        CompanyGroupId: null,
        Hours: null
      }
    };
  },
  computed: {
    formTitle() {
      return this.editedItem.Id === null ? "New Item" : "Edit Item";
    },
    ...mapGetters(TIMETRACKING_NAMESPACE, ["hours", "groups", "loading"])
  },
  watch: {
    dialog: /* istanbul ignore next */ function(val) {
      if (val === true && this.$refs.form) this.$refs.form.resetValidation();
    }
  },
  created: /* istanbul ignore next */ function() {
    this.$registerVuexModule(TIMETRACKING_NAMESPACE, timeTrackingModule);
    this.$isInRole([this.$roleDefs.ADMIN, this.$roleDefs.TIME_ADMIN]).then(
      res => {
        if (res) {
          this.loadHours();
          this.loadGroups();
        } else this.$goHome();
      }
    );
  },
  methods: {
    allowedDates: val =>
      ![0, 1, 2, 3, 4, 5].includes(
        moment(val, "YYYY-MM-DD")
          .toDate()
          .getDay()
      ),
    mouseOver(item) {
      item.hover = true;
      this.$forceUpdate();
    },
    mouseOut(item) {
      item.hover = false;
      this.$forceUpdate();
    },
    loadHours() {
      this.$store.dispatch(`${TIMETRACKING_NAMESPACE}/LOADHOURS`);
    },
    loadGroups() {
      this.$store.dispatch(`${TIMETRACKING_NAMESPACE}/LOADGROUPS`);
    },
    save() {
      this.formHasErrors = false;
      if (this.$refs.form.validate()) {
        var companyGroupId = this.editedItem.CompanyGroupId;
        var selectGroup = this.groups.find(x => x.Id == companyGroupId);
        this.editedItem.CompanyGroup.Name = selectGroup.Name;
        this.editedItem.CompanyGroup.Id = companyGroupId;
        if (this.editedItem.Id != null) {
          var id = this.editedItem.Id;
          var found = _.find(this.hours, function(num) {
            return num.Id === id;
          });
          Object.assign(found, this.editedItem);
          this.$store.dispatch(
            `${TIMETRACKING_NAMESPACE}/SAVE`,
            this.editedItem
          );
        } else {
          this.editedItem.Id = 0;
          this.$store.dispatch(
            `${TIMETRACKING_NAMESPACE}/SAVE`,
            this.editedItem
          );
        }
        this.close();
        return;
      }
      if (!this.editedItem.WeekEndingFormatted) this.formHasErrors = true;
      if (!this.editedItem.CompanyGroupId) this.formHasErrors = true;
      if (!this.editedItem.Hours) this.formHasErrors = true;
      if (this.formHasErrors) return false;
    },
    editItem(item) {
      this.editedItem = Object.assign({}, item);
      this.editedItem.CompanyGroupId = item.CompanyGroup.Id;
      this.editedItem.WeekEnding = moment(item.WeekEnding).format("YYYY-MM-DD");
      this.dialog = true;
    },
    closeDeleteDialog() {
      this.deleteDialog = false;
      this.deleteId = null;
    },
    deleteItem() {
      return this.$store
        .dispatch(`${TIMETRACKING_NAMESPACE}/DELETE`, this.deleteId)
        .then(() => this.closeDeleteDialog());
    },
    openDeleteDialog(id) {
      this.deleteDialog = true;
      this.deleteId = id;
    },
    close() {
      this.dialog = false;
      this.editedItem = Object.assign({}, this.defaultItem);
    }
  }
};
</script>
